import React from "react";

import styles from "./NoticeBanner.module.scss";

import { NoticeBannerPropsType } from "./types";

// Плашка объявлений клуба (тексты и сроки показа приходят с бэкенда)
export const NoticeBanner: React.FC<NoticeBannerPropsType> = ({ notices, newStyles }) => {
  if (!notices || notices.length === 0) {
    return null;
  }

  return (
    <div className={newStyles ? `${styles.notices} ${newStyles}` : styles.notices}>
      {notices.map((notice) => (
        <div
          key={notice.id}
          role={notice.variant === "warning" ? "alert" : "status"}
          className={`${styles.notice} ${
            notice.variant === "warning" ? styles.notice_warning : styles.notice_info
          }`}
        >
          <svg
            className={styles.icon}
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
          >
            <circle cx="10" cy="10" r="9" fill="currentColor" />
            {notice.variant === "warning" ? (
              <>
                <rect x="9" y="4.5" width="2" height="7" rx="1" fill="#ffffff" />
                <circle cx="10" cy="14.5" r="1.2" fill="#ffffff" />
              </>
            ) : (
              <>
                <circle cx="10" cy="5.8" r="1.2" fill="#ffffff" />
                <rect x="9" y="8.5" width="2" height="7" rx="1" fill="#ffffff" />
              </>
            )}
          </svg>
          <p className={styles.text}>{notice.text}</p>
        </div>
      ))}
    </div>
  );
};
